import { MutationCache } from "@tanstack/react-query"

import { avisar } from "./avisos"
import { codigoDe, mensajeDe } from "./errores"

/** Lo que dice un aviso: sólo el título, o título y texto. */
type Mensaje = string | { titulo: string; texto?: string }

/**
 * Truco de bivarianza: declarado como MÉTODO, TypeScript acepta aquí una función
 * cuyo primer parámetro es el tipo real de la mutación (`OrdenOut`…) y no
 * `unknown`. Sin esto, cada `meta.exito` con datos necesitaría un `as`.
 */
type DesdeDatos = { de(datos: never, variables: never): Mensaje }["de"]

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      /**
       * Si la mutación sale bien, un aviso de éxito con esto. La forma normal de
       * confirmar una acción: se declara junto a la mutación, no en cada pantalla.
       */
      exito?: Mensaje | DesdeDatos
      /**
       * Si falla, un aviso de error con este título y el mensaje del servidor.
       * ⚠ **Sólo donde el error NO se pinta ya en la pantalla** (un botón suelto de
       * una fila, una acción de menú). Donde hay formulario, el error va dentro y
       * con lo tecleado intacto; repetirlo en un aviso es decirlo dos veces.
       */
      error?: string
    }
  }
}

function comoMensaje(m: Mensaje): { titulo: string; texto?: string } {
  return typeof m === "string" ? { titulo: m } : m
}

export function crearCacheMutaciones(): MutationCache {
  return new MutationCache({
    onSuccess: (datos, variables, _resultado, mutacion) => {
      const exito = mutacion.meta?.exito
      if (exito === undefined) return
      const mensaje =
        typeof exito === "function"
          ? (exito as (d: unknown, v: unknown) => Mensaje)(datos, variables)
          : exito
      avisar({ tipo: "exito", ...comoMensaje(mensaje) })
    },
    onError: (error, _variables, _resultado, mutacion) => {
      const titulo = mutacion.meta?.error
      if (titulo === undefined) return
      avisar({
        tipo: "error",
        titulo,
        texto: mensajeDe(error, "Inténtalo de nuevo en un momento."),
        codigo: codigoDe(error),
      })
    },
  })
}
